/* global CVP */

// ### ENV
//
// Properties for the environment.

'use strict';

var App = require('./app');
var _ = require('./vendor/underscore');
var Util = require('./util');
var Promise = require('./vendor/machina.promise');
var _logger = require('./logger');
var MVPDConfig = require('./mvpdconfig');


var supports = {};

var queryParams = Util.parseQueryString(window.location.search);

function getConfigOverrideParam() {
	var authConfigEnv = 'authConfigEnv' in queryParams ? queryParams.authConfigEnv : null;
	return (authConfigEnv && _.contains(App.configEnvOptions, authConfigEnv)) ? authConfigEnv : null;
}

function getVendorOverrideParam() {
	return 'authVendorEnv' in queryParams ? queryParams.authVendorEnv : null;
}

var msEdgeRegex = /\bEdge\/\d+\./;
var ua = navigator.userAgent || '';
var isEdge = msEdgeRegex.test(ua);
var isIE = CVP.Browser.isBrowser(CVP.Browser.IE) || CVP.Browser.isEngine('Trident');
var requiresIframeLogin = isIE || isEdge;
var falseyRegex = /false|no|off/i;

supports.retina = Number(window.devicePixelRatio) >= 2;

supports.handleRedirect = (
	'forceHandleRedirect' in queryParams
	? !(falseyRegex.test(queryParams.forceHandleRedirect))
	: true
);

supports.popup = (
	'forcePopup' in queryParams
	// If 'forcePopup' query param is present and not falsey, return true.
	? !(falseyRegex.test(queryParams.forcePopup))
	// The AdobePass team recommends that for Internet Explorer you should implement the iFrame login.
	: !requiresIframeLogin
);

supports.refreshlessLogin = (
	'forceRefreshlessLogin' in queryParams
	? !(falseyRegex.test(queryParams.forceRefreshlessLogin))
	: true
);

supports.refreshlessLogout = (
	'forceRefreshlessLogout' in queryParams
	? !(falseyRegex.test(queryParams.forceRefreshlessLogout))
	: true
);

function determineLoginType(/*options*/) {
	var IFRAME = 'iframe', POPUP = 'popup', type = exports.supports.popup ? POPUP : IFRAME;

	// if (options.mvpdId === 'Dish') {
	// 	type = IFRAME;
	// }

	return type;
}

var geoPromise = new Promise();
var geoJsonpCallback = 'cvp_onGeolocationReceived';
var requested = false;

function resolveGeoPromise(value) {
	geoPromise.fulfill(value);
}

function onGeolocationSuccess(res) {
	_logger.debug('geolocation success', arguments);

	var code = App.UNKNOWN_COUNTRY;

	// Pull the country code value out of the response JSON.
	if (_.isObject(res) && _.isString(res.country)) {
		code = res.country;
	}

	resolveGeoPromise(code);
}

function onGeolocationFailure() {
	_logger.warn('geolocation failure', arguments);

	// In case of timeout or failure, use default.
	resolveGeoPromise(App.UNKNOWN_COUNTRY);
}

function requestGeolocation(url) {
	if (requested) {
		return;
	}

	requested = true;

	if (!url) {
		_logger.warn('No geolocation service URL provided.');
		onGeolocationFailure();
		return;
	}

	var geoServiceUrl = Util.augmentQueryString(url, {
		callback: geoJsonpCallback
	});

	_logger.debug('geolocation requested: ', geoServiceUrl);

	CVP.Ajax.getJSONP({
		url: geoServiceUrl,
		jsonpCallback: geoJsonpCallback,
		success: onGeolocationSuccess,
		error: onGeolocationFailure
	});
}

function getCountryCode() {
	var geoServiceUrl = MVPDConfig.getGeoServiceUrl();
	requestGeolocation(geoServiceUrl);
	return geoPromise;
}


exports.isEdge = isEdge;
exports.queryParams = queryParams;
exports.getVendorOverrideParam = getVendorOverrideParam;
exports.getConfigOverrideParam = getConfigOverrideParam;
exports.supports = supports;
exports.determineLoginType = determineLoginType;
exports.getCountryCode = getCountryCode;
